import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    cancel: string;
    select: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the cancel button in the export location dialog */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExportLocationDialog.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the select button in the export location dialog */
            select: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExportLocationDialog.select?c=1of9wmhs0jt7b", defaultMessage: "Select" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
